import React from 'react';
import AdsModalForm from './form';
import {notification} from 'antd';
import history from '../../modules/History';
import {addAdsModalItem} from '../../modules/Api';

class AddAdsModal extends React.Component {
    constructor() {
        super();
        var end = new Date();
        end.setHours(23,59,58);
        this.state = {
            data: {
                expiration_date: end
            },
            submitted: false,
            
        }

    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        console.log(values);
        this.setState({submitted: true});
        const formData = values;
        addAdsModalItem(formData, (res) => {
            this.setState({submitted:false});
            if(res.status && res.status==200) {
                notification.open({
                    message: `تبلیغ با موفقیت اضافه شد!`,
                    description: ``
                });
                history.item.push(`/ads-modal`);
            }
            else{
                notification.open({
                    message: 'خطایی رخ داده است.',
                    description: res.message
                });
            }
        });
    }
    render() {
        return (<div><AdsModalForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default AddAdsModal;


// WEBPACK FOOTER //
// ./src/containers/AdsModal/add.js